import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';
import {getCurrencySymbol} from '../../../utils/GetCurrency';

const ProductCard = ({ product, onEdit, onDuplicate, onArchive, onViewDetails }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'active':
        return 'bg-success text-success-foreground';
      case 'inactive':
        return 'bg-secondary text-secondary-foreground';
      case 'out_of_stock':
        return 'bg-error text-error-foreground';
      default:
        return 'bg-muted text-muted-foreground';
    }
  };
let currencySymbol = getCurrencySymbol();
  const getStatusText = (status) => {
    switch (status) {
      case 'active':
        return 'Active';
      case 'inactive':
        return 'Inactive';
      case 'out_of_stock':
        return 'Out of Stock';
      default:
        return 'Unknown';
    }
  };

  const getInventoryStatus = (quantity) => {
    if (quantity === 0) return { color: 'text-error', text: 'Out of Stock' };
    if (quantity <= 10) return { color: 'text-warning', text: 'Low Stock' };
    return { color: 'text-success', text: 'In Stock' };
  };

  const inventoryStatus = getInventoryStatus(product.inventory);

  return (
    <div className="bg-card border border-border rounded-lg p-4 hover:shadow-md micro-animation group">
      {/* Product Image */}
      <div className="relative mb-4">
        {/* <div className="w-full h-48 overflow-hidden rounded-md bg-muted">
          <Image
            src={product.image}
            alt={product.name}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-200"
          />
        </div> */}
        
        {/* Status Badge */}
        <div className={`absolute top-2 right-2 px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(product.status)}`}>
          {getStatusText(product.status)}
        </div>

        {/* Quick Actions */}
        <div className="absolute top-2 left-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200">
          <div className="flex space-x-1">
            <Button
              variant="secondary"
              size="icon"
              onClick={() => onEdit(product)}
              className="w-8 h-8 shadow-sm"
            >
              <Icon name="Edit" size={14} />
            </Button>
            {/* <Button
              variant="secondary"
              size="icon"
              onClick={() => onDuplicate(product)}
              className="w-8 h-8 shadow-sm"
            >
              <Icon name="Copy" size={14} />
            </Button> */}
          </div>
        </div>
      </div>

      {/* Product Info */}
      <div className="space-y-3">
        {/* Name and Category */}
        <div>
          <h3 className="font-semibold text-foreground text-lg mb-1 line-clamp-2">
            {product.name}
          </h3>
          <p className="text-sm text-muted-foreground">
            {product.category}
          </p>
        </div>

        {/* Price */}
        <div className="flex items-center justify-between">
          <div>
            <span className="text-2xl font-bold text-foreground">
           {currencySymbol}   {product?.price?.toFixed(2)}
            </span>
            {/* {product.originalPrice && product.originalPrice > product.price && (
              <span className="text-sm text-muted-foreground line-through ml-2">
                ${product.originalPrice.toFixed(2)}
              </span>
            )} */}
          </div>
          {/* {product.originalPrice && product.originalPrice > product.price && (
            <div className="bg-accent text-accent-foreground px-2 py-1 rounded text-xs font-medium">
              {Math.round(((product.originalPrice - product.price) / product.originalPrice) * 100)}% OFF
            </div>
          )} */}
        </div>

        {/* Inventory */}
        {/* <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <Icon name="Package" size={16} className="text-muted-foreground" />
            <span className="text-sm text-muted-foreground">
              {product.inventory} units
            </span>
          </div>
          <span className={`text-xs font-medium ${inventoryStatus.color}`}>
            {inventoryStatus.text}
          </span>
        </div> */}

        {/* Description */}
        {/* {product.description && (
          <p className="text-sm text-muted-foreground line-clamp-2">
            {product.description}
          </p>
        )} */}

        {/* Actions */}
        <div className="flex space-x-2 pt-2">
          <Button
            variant="outline"
            size="sm"
            onClick={() => onViewDetails(product)}
            className="flex-1"
          >
            View Details
          </Button>
          {/* <Button
            variant="ghost"
            size="icon"
            onClick={() => onArchive(product)}
            className="text-muted-foreground hover:text-error"
          >
            <Icon name="Archive" size={16} />
          </Button> */}
        </div>
      </div>
    </div>
  );
};

export default ProductCard;